/**
 * Common
 */
export const SUCCESS = 'SUCCESS';
export const FAIL = 'FAIL';
export const LOADER = 'LOADER';

/**
 * Auth
 */
export const SMS_AUTH_SUCCESS = 'SMS_AUTH_SUCCESS';

/**
 * Portfolio
 */
export const ARTICLES_SUCCESS = 'ARTICLES_SUCCESS';

/**
 * tags
 */
export const TAGS = 'TAGS';
